'use strict'

import fetch from '../../../libs/@elements/fetch';
import { getLoadingContainer, removeLoadingContainer } from "../../../scripts/loading";
import { showNotification } from '../../../libs/@elements/alert-notification';
import { initInScope as initRequestCart } from './request-cart';

export function initInScope($scope) {
    // Skip initialization if maintenance mode is active
    if ($(document).find('#maintenanceModal').length) {
        const showMaintenanceModal = function(e) {
            if ((e.type === 'submit' && $(e.target).find(':submit').hasClass('js__send-login')) || $(e.target).hasClass('product-detail-filter')) {
                return;
            }
            
            e.preventDefault();
            e.stopPropagation();
            
            const $modal = $('#maintenanceModal');

            $modal.modal('show');
            
            $modal.on('hidden.bs.modal', function() {
                $(this).modal('hide');
            });

            return false;
        };

        $('form').on('submit', showMaintenanceModal);
        $('.js_open-cart').on('click', showMaintenanceModal);
        $('form.js-cart__form').on('submit', showMaintenanceModal);
        $('.js-strex-summary__save').on('click', showMaintenanceModal);
        $('.js_block-maintenance').on('click', showMaintenanceModal);
        
    }
    if (!$('#maintenanceModal').length) {
        const $modal = $(document).find('.modal--add_to_cart');
        const
            $saveBtn = $scope.find('.js-strex-summary__save'),
            url = $saveBtn.data('href');

        let pendingRequest;
        $saveBtn.on('click', () => {
            if (pendingRequest) {
                pendingRequest.abort();
                pendingRequest = null;
            }
            pendingRequest = fetch(url, {
                method: 'post',
            })

            $(getLoadingContainer()).appendTo($saveBtn);

            showNotification(pendingRequest)

            pendingRequest.finally(() => {
                $("html, body").animate({
                    scrollTop: 0
                }, 300);
                removeLoadingContainer($saveBtn);
                pendingRequest = null;
            })
        });

        // Initialize request cart functionality
        initRequestCart($scope);

        const
            $addBtn = $scope.find('.js-strex-add_to_cart'),
            urlAdd = $addBtn.data('href');
        
        $addBtn.on('click', () => {
            if (pendingRequest) {
                pendingRequest.abort();
                pendingRequest = null;
            }
            pendingRequest = fetch(urlAdd, {
                method: 'post',
            })

            $(getLoadingContainer()).appendTo($addBtn);

            showNotification(pendingRequest)
            
            pendingRequest.finally(() => {
                $modal.modal('hide');
                console.log('hide modal');
                $("html, body").animate({
                    scrollTop: 0
                }, 300);

                removeLoadingContainer($addBtn);

                pendingRequest = null;
            })

        })

        $("body").on("click", ".js-ga4__send-data", function () {
            const eventName = $(this).attr('data-event');
            globalThis.dataLayer = globalThis.dataLayer || [];
            globalThis.dataLayer.push({
                event: eventName,
            });
        });
    }
}